import { StyleSheet, Platform, Dimensions } from 'react-native'

export default StyleSheet.create({
  containerStyle: {
    marginLeft: 8,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 5,
  },
  headerThirdRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 10,
  },
  iconStyle: {
    marginHorizontal: 8,
    opacity: 1,
  },
  lastUpdatedtext: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: 14,
    lineHeight: 18,
    marginTop: Platform.OS === 'ios' ? 2 : -1,
  }),
  shimmerContainer: { width: '50%', height: '10%' },
});
